import { render, staticRenderFns } from "./LayoutApp.vue?vue&type=template&id=add8c4a0&"
import script from "./LayoutApp.vue?vue&type=script&lang=js&"
export * from "./LayoutApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports